module.exports = __webpack_public_path__ + "img/screen-1.068440d7.png";